'use client';
import React from 'react';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { Box, List, ListItem, Stack } from '@mui/material';
import ReactHtmlParser from '@libs/reactHtmlParser';
import { Link } from '@components/Link';
import DynamicLogo from '@components/DynamicLogo';
import CommonContainer from '@components/CommonContainer';
import {
  IconFacebook,
  IconInstagram,
  IconLinkdin,
} from '@components/SVGIcon/Icons';
import ParallaxText from '@components/ParallaxText';
import cn from './style.module.scss';

type MenuItem = {
  url: string;
  label: string;
};
export default function WimbledonBridgeFooter(
  props: MarketingPageComponentProps
) {
  const wimbledonFooterAdress =
    props.locale.section.wimbledonBridgeFooterInformation || [];
  const wimbledonFooterNavigation =
    props.locale.section.wimbledonBridgeFooterNavigation || [];
  return (
    <Stack component="footer" className={cn.wimbledonBridgeFooter}>
      <Box className={cn.wimbledonFooterInner}>
        <CommonContainer
          maxWidth={{ xs: '100%', md: '1360px', lg: '1360px' }}
          flexGrow={1}
        >
          <Box className={cn.wimbledonFooterBlock}>
            <Box className={cn.wimbledonFooterMenu}>
              <List className={cn.wimbledonFooterList}>
                {wimbledonFooterNavigation?.map((item: MenuItem) => (
                  <ListItem key={item.url}>
                    <Link
                      url={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {ReactHtmlParser(item.label)}
                    </Link>
                  </ListItem>
                ))}
              </List>
            </Box>
            <Box className={cn.wimbledonFooterCompany}>
              <Box className={cn.wimbledonFooterCompany__element}>
                <DynamicLogo
                  logoImage={props?.images?.wimbledon_bridge_footer_logo?.src}
                  alt={'Wimbledon Bridge Logo'}
                />
              </Box>
              <Box className={cn.wimbledonFooterCompany__copyright}>
                <ParallaxText
                  variant="p"
                  animationType="slideInBottom"
                  animationDuration={500}
                >
                  {ReactHtmlParser(
                    props.locale.section['wimbledonBridgeFooterCopyright']
                  )}
                </ParallaxText>
              </Box>
            </Box>
            <Box className={cn.wimbledonFooterSocial}>
              <Box className={cn.wimbledonFooterSocial__address}>
                {wimbledonFooterAdress?.map((item: string, index: number) => (
                  <p key={index}>{item}</p>
                ))}
              </Box>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
